import React from "react";

/**
 * Underline-style tabs. Controlled — parent supplies `value` and `onChange`.
 * @param {Object} props
 * @param {string} props.value
 * @param {(next:string)=>void} props.onChange
 * @param {Array<{value:string, label:string}>} props.items
 */
export function Tabs({ value, onChange, items = [] }) {
  return (
    <div className="ds-comp-tabs" role="tablist">
      {items.map((t) => (
        <button
          key={t.value}
          role="tab"
          aria-selected={value === t.value}
          className={`ds-comp-tab ${value === t.value ? "is-active" : ""}`.trim()}
          onClick={() => onChange(t.value)}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
